import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme, ZIndexLayer } from "shared/lib/styles";

type FloatingButtonProps = {
  $hasTooltip?: boolean;
  $hideLabelInMobile: boolean;
  $takeoverOffset?: string;
  $type: "link" | "popup";
};

export const FloatingButtonWrapper = styled.div<FloatingButtonProps>`
  position: fixed;
  inset-block-end: 24px;
  inset-inline-end: 24px;
  z-index: ${ZIndexLayer.FloatingButton};

  display: flex;
  gap: 8px;
  align-items: center;

  padding-block: 8px;
  padding-inline: 16px 8px;

  border-radius: 100px;

  background-color: ${props => (props.$type === "popup" ? "#ffca05" : "#788AC4")};

  box-shadow: 0 2px 8px rgb(0 0 0 / 0.15);

  cursor: pointer;

  ${props =>
    props.$takeoverOffset
      ? css`
          inset-block-end: ${props.$takeoverOffset};
        `
      : ""}

  ${props =>
    props.$hasTooltip
      ? css`
          padding-inline: ${props.$hideLabelInMobile ? "8px" : "16px 8px"};
          ${theme.breakpoints.up("tablet")} {
            padding-inline: 16px 8px;
          }
        `
      : css`
          padding-inline: 8px;
        `}


  ${props =>
    props.$type === "link" &&
    css`
      color: #ffffff;
    `}

  ${theme.breakpoints.down("tablet")} {
    inset-block-end: 16px;
    inset-inline-end: 16px;
  }
`;

type TooltipLabelProps = {
  $hideLabelInMobile: boolean;
};
export const TooltipLabel = styled.div<TooltipLabelProps>`
  display: ${props => (props.$hideLabelInMobile ? "none" : "block")};

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 100%;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

type FloatingButtonIconProps = {
  $type: "link" | "popup";
};
export const FloatingButtonIcon = styled.button<FloatingButtonIconProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 40px;
  block-size: 40px;
  padding: 0;

  border: none;
  border-radius: 50%;

  background-color: #001246;

  cursor: pointer;

  svg {
    inline-size: 24px;
    block-size: 24px;

    fill: #ffca05;

    ${props =>
      props.$type === "popup"
        ? css`
            inline-size: 24px;
            block-size: 24px;

            fill: #ffca05;
          `
        : css`
            inline-size: 26px;
            block-size: 26px;
          `}
  }
`;

export const PopupOverlay = styled.div`
  position: fixed;
  inset-block: 0;
  inset-inline: 0;
  z-index: ${ZIndexLayer.FloatingButtonPopupOverlay};

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgb(0 0 0 / 0.5);
`;

export const PopupContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  inline-size: 90vw;
  block-size: 580px;
  max-inline-size: 800px;

  border-radius: 8px;

  background-color: #ffffff;

  box-shadow: 0 4px 24px rgb(0 0 0 / 0.2);

  ${theme.breakpoints.down("tablet")} {
    inline-size: 95vw;
  }
`;

export const PopupIframe = styled.iframe`
  flex: 1;

  inline-size: 100%;
  block-size: 100%;

  border: none;
  border-radius: 8px;
`;

export const CloseButton = styled.button`
  position: absolute;
  inset-block-start: -12px;
  inset-inline-end: -12px;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 32px;
  block-size: 32px;
  padding: 0;

  border: none;
  border-radius: 50%;

  background-color: #ffffff;

  box-shadow: 0 2px 4px rgb(0 0 0 / 0.2);

  cursor: pointer;

  transition:
    transform 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    background-color: #f5f5f5;

    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }

  svg {
    inline-size: 16px;
    block-size: 16px;

    fill: #333333;
  }
`;
